import { render } from "./pos-company.vue?vue&type=template&id=0ff11ea1&scoped=true"
import script from "./pos-company.vue?vue&type=script&lang=js"
export * from "./pos-company.vue?vue&type=script&lang=js"

import "./pos-company.vue?vue&type=style&index=0&id=0ff11ea1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ff11ea1"]])

export default __exports__